import { useMutation } from '@tanstack/react-query';
import { DIAM_API_PATH, getInvitationLink } from '../../diamApi';
import { useApiEssentials } from '../../../../shared/hooks/useApiEssentials';

export function useInvitationLink() {
  const { getIdToken, apiUrl } = useApiEssentials(DIAM_API_PATH);

  return useMutation({
    mutationFn: async (invitationId: string) => {
      const idToken = await getIdToken();
      return getInvitationLink(apiUrl, idToken, invitationId);
    },
  });
}
